<template>
  <section class="section__banks">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="9" lg="10" class="section__banks-data px-5">
          <v-card class=" ">
            <!-- delete -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5">آیا اطمینان دارید ؟</v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue-darken-1"
                    variant="text"
                    @click="closeDelete"
                    >لغو</v-btn
                  >
                  <v-btn color="error" variant="text" @click="deleteItemConfirm"
                    >بله</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Add -->
            <v-dialog
              transition="dialog-bottom-transition"
              max-width="800"
              v-model="addForm"
            >
              <v-card class="">
                <v-card-title-close @close="addForm = false">
                  ایجاد
                </v-card-title-close>
                <v-form ref="formAdd">
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          label="شخص / شرکت"
                          outlined
                          dense
                          hide-details
                          v-model="addData.name"
                          :rules="requiredRule"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          label="کد"
                          outlined
                          dense
                          hide-details
                          v-model="addData.code"
                          :rules="requiredRule"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="شماره تماس"
                          outlined
                          hide-details
                          dense
                          v-model="addData.tell"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="8">
                        <v-text-field
                          label="شماره همراه"
                          outlined
                          hide-details
                          dense
                          v-model="addData.mobile"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          label="شماره واتس اپ"
                          hide-details
                          dense
                          v-model="addData.whatsApp"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="ایمیل"
                          outlined
                          hide-details
                          dense
                          v-model="addData.email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          outlined
                          label="توضیحات"
                          rows="4"
                          row-height="30"
                          hide-details
                          v-model="addData.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="addData.customerGroups"
                          :items="allGroups"
                          item-text="customerGroupTitle"
                          item-value="customerGroupId"
                          outlined
                          dense
                          hide-details
                          chips
                          small-chips
                          label="گروه های مشتری"
                          multiple
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-row>
                          <v-col cols="2"
                            ><v-icon
                              type="button"
                              class="mt-3"
                              @click="addDataCreatedDateCalendarShow = true"
                            >
                              mdi-calendar
                            </v-icon>
                          </v-col>
                          <v-col cols="10">
                            <v-text-field
                              v-model="addData.createdDate"
                              id="addData.createdDate"
                              type="text"
                              outlined
                              dense
                              @click="addDataCreatedDateCalendarShow = true"
                              label="تاریخ ایجاد"
                              :rules="nameRules"
                              readonly
                            >
                            </v-text-field>
                            <date-picker
                              v-model="addData.createdDate"
                              :show="addDataCreatedDateCalendarShow"
                              :auto-submit="true"
                              :editable="true"
                              custom-input="#addData.createdDate"
                              @close="addDataCreatedDateCalendarShow = false"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-row>
                          <v-col cols="2"
                            ><v-icon
                              type="button"
                              class="mt-3"
                              @click="addDataCreditDateCalendarShow = true"
                            >
                              mdi-calendar
                            </v-icon></v-col
                          >
                          <v-col cols="10">
                            <v-text-field
                              v-model="addData.creditDate"
                              id="addData.creditDate"
                              type="text"
                              outlined
                              dense
                              @click="addDataCreditDateCalendarShow = true"
                              label="تاریخ اعتبار"
                              :rules="nameRules"
                              readonly
                            ></v-text-field>
                            <date-picker
                              v-model="addData.creditDate"
                              :show="addDataCreditDateCalendarShow"
                              :auto-submit="true"
                              :editable="true"
                              custom-input="#addData.creditDate"
                              @close="addDataCreditDateCalendarShow = false"
                            />
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12">
                        <v-combobox
                          v-model="addData.tags"
                          label="برچسب ها"
                          multiple
                          small-chips
                        >
                          <template
                            v-slot:selection="{ attrs, item, parent, selected }"
                          >
                            <v-chip
                              v-bind="attrs"
                              :input-value="selected"
                              label
                              small
                            >
                              <span class="pl-2">
                                {{ item }}
                              </span>
                              <v-icon small @click="parent.selectItem(item)">
                                $delete
                              </v-icon>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12">
                        <v-btn small v-on:click="addAgent"
                          ><v-icon small>mdi-plus</v-icon>افزودن نماینده</v-btn
                        >
                      </v-col>
                      <v-col cols="12">
                        <v-row
                          v-for="(item, index) in addData.agents"
                          :key="index"
                        >
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="نام"
                              outlined
                              hide-details
                              dense
                              v-model="addData.agents[index].name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="موبایل"
                              outlined
                              hide-details
                              dense
                              v-model="addData.agents[index].mobile"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="تلفن"
                              outlined
                              hide-details
                              dense
                              v-model="addData.agents[index].tell"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="سمت"
                              outlined
                              hide-details
                              dense
                              v-model="addData.agents[index].aff"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="ایمیل"
                              outlined
                              hide-details
                              dense
                              v-model="addData.agents[index].email"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-divider></v-divider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
                <v-card-actions class="justify-center">
                  <v-btn v-on:click="addItem()" class="success">افزودن</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Edit -->
            <v-dialog
              transition="dialog-bottom-transition"
              max-width="800"
              v-model="editForm"
            >
              <v-card>
                <v-card-title-close @close="editForm = false">
                  ویرایش
                </v-card-title-close>
                <v-form ref="formEdit">
                  <v-card-text v-if="editData.data">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field
                          label="شخص / شرکت"
                          outlined
                          dense
                          hide-details
                          v-model="editData.data.name"
                          :rules="requiredRule"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          label="کد"
                          outlined
                          dense
                          hide-details
                          v-model="editData.data.code"
                          :rules="requiredRule"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="شماره تماس"
                          outlined
                          hide-details
                          dense
                          v-model="editData.data.tell"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" lg="8">
                        <v-text-field
                          label="شماره همراه"
                          outlined
                          hide-details
                          dense
                          v-model="editData.data.mobile"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          label="شماره واتس اپ"
                          hide-details
                          dense
                          v-model="editData.data.whatsApp"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          label="ایمیل"
                          outlined
                          hide-details
                          dense
                          v-model="editData.data.email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          outlined
                          label="توضیحات"
                          rows="4"
                          row-height="30"
                          hide-details
                          v-model="editData.data.description"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="editData.data.customerGroups"
                          :items="allGroups"
                          item-text="customerGroupTitle"
                          item-value="customerGroupId"
                          outlined
                          dense
                          hide-details
                          chips
                          small-chips
                          label="گروه های مشتری"
                          multiple
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-row>
                          <v-col cols="2"
                            ><v-icon
                              type="button"
                              class="mt-3"
                              @click="editDataCreatedDateCalendarShow = true"
                            >
                              mdi-calendar
                            </v-icon></v-col
                          >
                          <v-col cols="10">
                            <v-text-field
                              v-model="editData.data.createdDate"
                              id="editData.data.createdDate"
                              type="text"
                              outlined
                              dense
                              @click="editDataCreatedDateCalendarShow = true"
                              label="تاریخ ایجاد"
                              :rules="nameRules"
                              readonly
                            ></v-text-field>
                            <date-picker
                              v-model="editData.data.createdDate"
                              :show="editDataCreatedDateCalendarShow"
                              :auto-submit="true"
                              :editable="true"
                              custom-input="#editData.data.createdDate"
                              @close="editDataCreatedDateCalendarShow = false"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="6">
                        <v-row>
                          <v-col cols="2"
                            ><v-icon
                              type="button"
                              class="mt-3"
                              @click="editDataCreditDateCalendarShow = true"
                            >
                              mdi-calendar
                            </v-icon></v-col
                          >
                          <v-col cols="10">
                            <v-text-field
                              v-model="editData.data.creditDate"
                              id="editData.data.creditDate"
                              type="text"
                              outlined
                              dense
                              @click="editDataCreditDateCalendarShow = true"
                              label="تاریخ اعتبار"
                              :rules="nameRules"
                              readonly
                            ></v-text-field>
                            <date-picker
                              v-model="editData.data.creditDate"
                              :show="editDataCreditDateCalendarShow"
                              :auto-submit="true"
                              :editable="true"
                              custom-input="#editData.data.creditDate"
                              @close="editDataCreditDateCalendarShow = false"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-combobox
                          v-model="editData.data.tags"
                          label="برچسب ها"
                          multiple
                          small-chips
                        >
                          <template
                            v-slot:selection="{ attrs, item, parent, selected }"
                          >
                            <v-chip
                              v-bind="attrs"
                              :input-value="selected"
                              label
                              small
                            >
                              <span class="pl-2">
                                {{ item }}
                              </span>
                              <v-icon small @click="parent.selectItem(item)">
                                $delete
                              </v-icon>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="12">
                        <v-btn small v-on:click="addAgentEdit"
                          ><v-icon small>mdi-plus</v-icon>افزودن نماینده</v-btn
                        >
                      </v-col>
                      <v-col cols="12">
                        <v-row
                          v-for="(item, index) in editData.data.customerAgents"
                          :key="index"
                        >
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="نام"
                              outlined
                              hide-details
                              dense
                              v-model="editData.data.customerAgents[index].name"
                              :rules="requiredRule"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="موبایل"
                              outlined
                              hide-details
                              dense
                              v-model="
                                editData.data.customerAgents[index].mobile
                              "
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="تلفن"
                              outlined
                              hide-details
                              dense
                              v-model="editData.data.customerAgents[index].tell"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" lg="6">
                            <v-text-field
                              label="سمت"
                              outlined
                              hide-details
                              dense
                              v-model="editData.data.customerAgents[index].aff"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              label="ایمیل"
                              outlined
                              hide-details
                              dense
                              v-model="
                                editData.data.customerAgents[index].email
                              "
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12"> <v-divider></v-divider> </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-form>
                <v-card-actions class="justify-center">
                  <v-btn v-on:click="editItem()" class="success">ویرایش</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Attachment -->
            <v-dialog
              transition="dialog-bottom-transition"
              max-width="800"
              v-model="attachmentForm"
            >
              <v-card class="rounded-lg">
                <v-card-title-close @close="attachmentForm = false">
                  پیوست
                </v-card-title-close>
                <v-card-text>
                  <v-data-table
                    :headers="headersAttachment"
                    :items="attachmentList"
                    :loading="attachmentLoading"
                  >
                    <template v-slot:[`item.creatorUserId`]="{ item }">
                      <span dense>{{
                        getManCompanyFk(item.creatorUserId)
                      }}</span>
                    </template>
                    <template v-slot:[`item.createdDate`]="{ item }">
                      <span>{{ toPersianDateTime(item.createdDate) }}</span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <a
                            v-bind="attrs"
                            v-on="on"
                            :href="
                              getUrl +
                              '/customer/download?id=' +
                              item.customerAttachmentId +
                              '&token=' +
                              token
                            "
                          >
                            <v-icon> mdi-download </v-icon>
                          </a>
                        </template>
                        <span>دانلود</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            @click="deleteAttachment(item)"
                            color="error"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>حذف</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-col cols="6" offset="2">
                    <v-file-input
                      v-model="image"
                      color="deep-purple-accent-4"
                      counter
                      label="انتخاب فایل"
                      placeholder="انتخاب فایل"
                      prepend-icon="mdi-paperclip"
                      variant="outlined"
                      :show-size="1000"
                      v-show="true"
                      ref="fileInput"
                      accept="image/*"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="4">
                    <v-btn
                      class="mx-1 my-1"
                      compact
                      color="success"
                      v-on:click="uploadAttachment()"
                      :disabled="this.image == null"
                    >
                      <v-icon small>mdi-undo</v-icon>
                      آپلود
                    </v-btn>
                  </v-col>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- contact -->
            <v-dialog
              transition="dialog-bottom-transition"
              max-width="800"
              v-model="contactForm"
            >
              <v-card class="rounded-lg">
                <v-card-title-close @close="contactForm = false">
                  تماس های مشتری
                </v-card-title-close>
                <v-card-text>
                  <v-card class="rounded-lg">
                    <v-card-actions>
                      <v-btn
                        class="mr-2 success"
                        @click="contactAddForm = true"
                      >
                        <v-icon small> mdi-plus </v-icon>
                        افزودن
                      </v-btn>
                    </v-card-actions>
                    <v-card-title>
                      <v-text-field
                        v-model="searchContact"
                        outlined
                        dense
                        append-icon="mdi-magnify"
                        label="جستجو"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-card-title>
                    <v-card-text>
                      <v-dialog
                        transition="dialog-bottom-transition"
                        max-width="600"
                        v-model="contactAddForm"
                      >
                        <v-form ref="contactAddForm">
                          <v-card>
                            <v-card-title>ایجاد</v-card-title>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    label="عنوان"
                                    outlined
                                    hide-details
                                    dense
                                    v-model="contactAddData.title"
                                    :rules="requiredRule"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="1"
                                      ><v-icon
                                        type="button"
                                        class="mt-3"
                                        @click="showContactDatepicker = true"
                                      >
                                        mdi-calendar
                                      </v-icon></v-col
                                    >
                                    <v-col cols="11">
                                      <v-text-field
                                        v-model="contactAddData.date"
                                        id="contactAddData.date"
                                        type="text"
                                        outlined
                                        dense
                                        label="تاریخ"
                                        :rules="requiredRule"
                                        @click="showContactDatepicker = true"
                                        readonly
                                      ></v-text-field>
                                      <date-picker
                                        v-model="contactAddData.date"
                                        :show="showContactDatepicker"
                                        :auto-submit="true"
                                        :editable="true"
                                        custom-input="#contactAddData.date"
                                        @close="showContactDatepicker = false"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                              <v-btn
                                v-on:click="addContactItem()"
                                class="success"
                              >
                                افزودن
                              </v-btn>
                              <v-btn v-on:click="contactAddForm = false">
                                لغو
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-dialog>
                      <v-dialog
                        transition="dialog-bottom-transition"
                        max-width="600"
                        v-model="contactEditForm"
                      >
                        <v-form ref="contactEditForm">
                          <v-card>
                            <v-card-title>ویرایش</v-card-title>

                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    label="عنوان"
                                    outlined
                                    hide-details
                                    dense
                                    v-model="contactEditData.data.title"
                                    :rules="requiredRule"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="1"
                                      ><v-icon
                                        type="button"
                                        class="mt-3"
                                        @click="showContactDatepicker2 = true"
                                      >
                                        mdi-calendar
                                      </v-icon></v-col
                                    >
                                    <v-col cols="11">
                                      <v-text-field
                                        v-model="contactEditData.data.date"
                                        id="contactEditData.data.date"
                                        type="text"
                                        outlined
                                        dense
                                        label="تاریخ"
                                        :rules="requiredRule"
                                        @click="showContactDatepicker2 = true"
                                        readonly
                                      ></v-text-field>
                                      <date-picker
                                        v-model="contactEditData.data.date"
                                        :show="showContactDatepicker2"
                                        :auto-submit="true"
                                        :editable="true"
                                        custom-input="#contactEditData.data.date"
                                        @close="showContactDatepicker2 = false"
                                      />
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>

                            <v-card-actions>
                              <v-btn
                                v-on:click="editContactItem()"
                                class="success"
                              >
                                ویرایش
                              </v-btn>
                              <v-btn v-on:click="contactEditForm = false"
                                >لغو</v-btn
                              >
                            </v-card-actions>
                          </v-card>
                        </v-form>
                      </v-dialog>

                      <v-data-table
                        :headers="headerContacts"
                        :items="contactList"
                        :items-per-page="5"
                        :loading="contactLoading"
                      >
                        <template v-slot:[`item.date`]="{ item }">
                          <span>{{ toPersianDate(item.date) }}</span>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                dense
                                class="ma-1"
                                @click="openContctEditForm(item)"
                              >
                                mdi-pencil
                              </v-icon>
                            </template>
                            <span>ویرایش</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                dense
                                class="ma-1"
                                color="error"
                                @click="deleteContact(item)"
                              >
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>حذف</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-dialog>

            <v-card-actions>
              <v-row>
                <v-col cols="6">
                  <v-card-title>{{ title }}</v-card-title>
                </v-col>
                <v-col cols="6" class="text-end">
                  <Help
                    v-on:ShowHelp="getDataShowHelp"
                    :sendDataHelp="sampleHelp"
                  ></Help>
                </v-col>
                <v-col cols="12">
                  <v-btn class="mr-2 success" @click="addForm = true">
                    <v-icon small>mdi-plus</v-icon>
                    افزودن
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-title>
              <v-text-field
                v-model="search"
                outlined
                dense
                append-icon="mdi-magnify"
                label="جستجو"
                @input="searchBoxChanged"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>

            <!-- Main -->
            <v-card-text>
              <div>
                <v-data-table
                  :headers="headers"
                  :items="customers"
                  hide-default-footer
                  :items-per-page="pageSize"
                  :server-items-length="total"
                  :page="pageNo"
                  :fixed-header="true"
                  :loading="loading"
                >
                  <template v-slot:[`item.index`]="{ index }">
                    {{ startIndex + index + 1 }}
                  </template>
                  <template v-slot:[`item.name`]="{ item }">
                    <router-link
                      :to="{
                        name: 'Customer',
                        params: {
                          id: Number(item.customerId),
                        },
                      }"
                      ><span>{{ item.name }}</span>
                    </router-link>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <router-link
                          style="color: white"
                          :to="{
                            name: 'Customer',
                            params: {
                              id: Number(item.customerId),
                            },
                          }"
                        >
                          <v-icon v-bind="attrs" v-on="on" dense class="ma-1">
                            mdi-eye
                          </v-icon>
                        </router-link>
                      </template>
                      <span>پیوست</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          dense
                          class="ma-1"
                          @click="openFormAttachment(item)"
                        >
                          mdi-paperclip
                        </v-icon>
                      </template>
                      <span>پیوست</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          dense
                          class="ma-1"
                          @click="openFormContact(item)"
                        >
                          mdi-phone-hangup
                        </v-icon>
                      </template>
                      <span>تماس ها</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          dense
                          v-bind="attrs"
                          v-on="on"
                          class="ma-1"
                          @click="openFormEdit(item)"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>ویرایش</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          dense
                          v-bind="attrs"
                          v-on="on"
                          color="error"
                          class="ma-1"
                          @click="deleteItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                      <span>حذف</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
                <div class="text-center pt-2"></div>
                <v-row>
                  <v-col cols="12" v-if="pagesCount > 1">
                    <v-pagination
                      :value="pageNo"
                      :length="pagesCount"
                      @input="handlePageChange"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="3" lg="2" class="section__banks-sidbar">
          <MenuLeft></MenuLeft>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import axios from "axios";
import MenuLeft from "../../../components/MenuLeft";
import VCardTitleClose from "../../../components/VCardTitleClose";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Help from "../../../components/Help.vue";
import { mapGetters, mapState } from "vuex";
import { myMixin } from "../../../../mixins.js";
import { customerMixin } from "../mixins";
import moment from "jalali-moment";
import { reactive } from "vue";
export default {
  mixins: [myMixin, customerMixin],
  name: "CustomersList",
  components: {
    VCardTitleClose,
    MenuLeft,
    Help,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      nonce: 1,
      items: [
        { header: "Select an option or create one" },
        {
          text: "Foo",
          color: "blue",
        },
        {
          text: "Bar",
          color: "red",
        },
      ],
      editing: null,

      token: localStorage.getItem("token"),
      title: "لیست مشتریان",
      search: "",
      contactForm: false,
      attachmentForm: false,
      dialogDelete: false,
      addForm: false,
      editForm: false,
      selectedCustomer: null,
      addDataCreatedDateCalendarShow: false,
      addDataCreditDateCalendarShow: false,
      editDataCreatedDateCalendarShow: false,
      editDataCreditDateCalendarShow: false,
      sampleHelp: {
        modal: false,
        title: "مشتریان",
        des: "ورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی هدف بهبود ابزارهای کاربردی می باشد. کتایپ به پایان رسد ومورد استفاده قرار گیرد.",
        audio: "",
        video: "",
      },
      showContactDatepicker: false,
      showContactDatepicker2: false,
      select: [],
      Customer: [],
      numberAgent: 0,
      addData: reactive({
        name: null,
        tell: null,
        mobile: null,
        whatsApp: false,
        email: null,
        description: null,
        tags: [],
        customerGroups: [],
        agents: [],
      }),
      editData: {},
      removeData: { url: "customer/delete/" },
      contactAddData: {
        url: "customercontact/create/",
        title: null,
        date: null,
        customerFk: null,
      },
      contactEditData: {
        url: "customercontact/update/",
        data: {
          title: null,
          date: null,
          customerFk: null,
        },
      },
      paymentAddData: {
        url: "contractpayment/create/",
      },
      headers: [
        {
          text: "#",
          value: "index",
          align: "start",
          sortable: false,
        },
        {
          text: "عنوان مشتری",
          align: "start",
          value: "name",
          sortable: false,
        },
        {
          text: "گروه های مشتری",
          align: "start",
          value: "allCustomerGroup",
          sortable: false,
        },
        { text: "", value: "actions", align: "end", sortable: false },
      ],

      //attachment
      attachmentLoading: false,
      headersAttachment: [
        {
          text: "عنوان فایل",
          align: "start",
          value: "attachmentFileName",
        },
        {
          text: "ایجاد کننده",
          align: "start",
          value: "creatorUserId",
        },
        {
          text: "تاریخ",
          align: "start",
          value: "createdDate",
        },
        { text: "", value: "actions", align: "end", sortable: false },
      ],
      attachmentList: [],
      searchAttachment: "",
      image: null,

      //contact
      headerContacts: [
        {
          text: "عنوان",
          align: "start",
          value: "title",
        },
        {
          text: "تاریخ",
          align: "start",
          value: "date",
        },
        { text: "", value: "actions", align: "end", sortable: false },
      ],
      searchContact: "",
      contactList: [],
      allContactList: [],
      contactLoading: false,
      contactAddForm: false,
      contactEditForm: false,
    };
  },
  computed: {
    ...mapState({
      customers: (state) => state.customers.items,
      loading: (state) => state.customers.listLoading,
      pageNo: (state) => state.customers.pageNo,
      pageSize: (state) => state.customers.pageSize,
      total: (state) => state.customers.total,
      allGroups: (state) => state.customers.groups.items,
      groupsLoading: (state) => state.customers.groups.loading,

      refreshList: (state) => state.customers.refreshList,
    }),
    ...mapGetters(["getPersonList", "getUrl"]),
    attachmentUrl() {
      return this.getUrl + "/Customer/UploadFile/";
    },
    pagesCount() {
      return Math.ceil(this.total / this.pageSize);
    },
    startIndex() {
      return (this.pageNo - 1) * this.pageSize;
    },
  },
  created() {
    this.getCustomers(1, 10, "");
    this.getCustomerGroups(1, -1, "");
    this.getHelpData();
    this.getPerson();
  },
  watch: {
    refreshList() {
      this.getCustomers(this.pageNo, this.pageSize, this.query);
    },
    searchContact(v) {
      v == ""
        ? (this.contactList = this.allContactList)
        : (this.contactList = this.allContactList.filter((x) =>
            x.title.includes(v)
          ));
    },
  },
  methods: {
    getHelpData() {},
    handlePageChange(pageNo) {
      this.getCustomers(pageNo, this.pageSize, this.search);
    },
    searchBoxChanged() {
      this.getCustomers(1, this.pageSize, this.search);
    },
    getDataShowHelp(/*item*/) {
      this.sampleHelp.modal = !this.sampleHelp.modal;
    },
    getData(item) {
      this.getCustomer(item.customerId)
        .then((response) => {
          this.select = [];
          this.customer = [];
          this.editData.data = response.data.record;
          this.editData.data.createdDate = this.toPersianDate(
            response.data.createdDate
          );
          this.editData.data.creditDate = this.toPersianDate(
            response.data.creditDate
          );
          this.editData.data.customerAgents = response.data.customerAgents;
          this.attachmentList = response.data.attachments;
          this.contactAddData.customerFk = item.customerId;
          this.select = response.data.tags;
          this.Customer = response.data.groups;
          this.editData.data.customerGroups = [];
          for (const item of this.customer) {
            this.editData.data.customerGroups.push(item.customerGroupId);
          }
          this.editData.data.tags = [];
          for (const item of this.select) {
            this.editData.data.tags.push(item.phrase);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getDataRemoveAttachment(item) {
      console.log(item, "item");
      axios
        .post(`${this.getUrl}/customer/deleteuploadfile/`, {
          Id: item.customerAttachmentId,
          Language: 0,
        })
        .then((/*response*/) => {})
        .catch((error) => {
          console.log(error);
        });
    },
    getDataContact(customerFk) {
      this.contactList = [];
      this.contactLoading = true;
      axios
        .get(`${this.getUrl}/customercontact/list/`, {
          params: {
            Count: 1000,
            Page: 1,
            Phrase: "",
            CustomerFk: customerFk,
            Language: 0,
          },
        })
        .then((data) => {
          this.contactList = data.data.records;
          this.allContactList = data.data.records;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.contactLoading = false;
        });
    },
    getDataAttachment(customerFk) {
      this.attachmentList = [];
      this.attachmentLoading = true;
      axios
        .get(`${this.getUrl}/customer/attachmentlist/`, {
          params: {
            Count: 1000,
            Page: 1,
            Phrase: "",
            customerFk: customerFk,
            Language: 0,
          },
        })
        .then((data) => {
          this.attachmentList = data.data.records;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.attachmentLoading = false;
        });
    },
    uploadAttachment() {
      axios
        .post(
          `${this.attachmentUrl}`,
          {
            Attachment: this.image,
            CustomerFk: this.selectedCustomer.customerId,
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((data) => {
          if (data.data.status == 1) {
            this.$store.commit("setMessage", {
              message: "درخواست با موفقیت انجام شد",
              color: "success",
              timeOut: 2000,
            });
            //this.getData(e.item);
          } else {
            this.$store.commit("setMessage", {
              message: data.data.messge,
              color: "red",
              timeOut: 2000,
            });
          }
        })
        .catch((error) => {
          this.$store.commit("setMessage", {
            message: error.message,
            color: "red",
            timeOut: 2000,
          });
          console.log(error);
        });
    },
    addAgent() {
      this.addData.agents.push({
        customerAgentId: 0,
        name: null,
        aff: null,
        tell: null,
        mobile: null,
        whatsApp: true,
        email: null,
      });
    },
    addAgentEdit() {
      this.editData = {
        ...this.editData,
        data: {
          ...this.editData.data,
          customerAgents: [
            ...this.editData.data.customerAgents,
            {
              customerAgentId: 0,
              name: null,
              aff: null,
              tell: null,
              mobile: null,
              whatsApp: true,
              email: null,
            },
          ],
        },
      };
    },
    removeAgent() {
      this.numberAgent--;
    },
    getCustomerContact() {
      this.$store.dispatch("sendListCustomerContact", {
        url: "customercontact/list/",
        id: 38,
      });
    },
    updatePaymentAddEndDate(date) {
      this.contactAddData.date = moment(date).locale("fa").format("YYYY/MM/DD");
    },
    updatePaymentEditEndDate(date) {
      this.contactEditData.data.date = moment(date)
        .locale("fa")
        .format("YYYY/MM/DD");
    },

    showAddDialog() {
      this.addData = {
        name: null,
        tell: null,
        mobile: null,
        whatsApp: false,
        email: null,
        description: null,
        creditDate: null,
        createdDate: false,
        tags: [],
        customerGroups: [],
        agents: [],
      };
    },
    addItem() {
      if (this.$refs.formAdd.validate()) {
        this.addData.createdDate = moment
          .from(this.addData.createdDate, "fa", "YYYY/MM/DD")
          .locale("en")
          .format("YYYY-MM-DDThh:mm:ss");
        this.addData.creditDate = moment
          .from(this.addData.creditDate, "fa", "YYYY/MM/DD")
          .locale("en")
          .format("YYYY-MM-DDThh:mm:ss");
        this.createCustomer(this.addData);
        this.addForm = false;
      }
    },

    openFormEdit(item) {
      this.editData.data = { ...item };
      this.editData.data.customerGroups =
        this.editData.data.customerGroupMember.map((e) => e.customerGroupFk);
      this.editData.data.createdDate = this.toPersianDate(
        this.editData.data.createdDate
      );

      this.editData.data.creditDate = this.toPersianDate(
        this.editData.data.creditDate
      );
      this.editData.data.tags = item.customerTags
        .map((a) => a.tags)
        .map((a) => a.phrase);

      this.editForm = true;
    },
    editItem() {
      if (this.$refs.formEdit.validate()) {
        (this.editData.data.createdDate = moment
          .from(this.editData.data.createdDate, "fa", "YYYY/MM/DD")
          .locale("en")
          .format("YYYY-MM-DDThh:mm:ss")),
          (this.editData.data.creditDate = moment
            .from(this.editData.data.creditDate, "fa", "YYYY/MM/DD")
            .locale("en")
            .format("YYYY-MM-DDThh:mm:ss")),
          this.updateCustomer(
            this.editData.data.customerId,
            this.editData.data
          );
        this.editForm = false;
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.removeData = item;
      this.removeData.url = "customer/delete/";
    },
    deleteItemConfirm() {
      if (this.removeData.url == "customer/delete/") {
        this.deleteCustomer(this.removeData.customerId);
        this.closeDelete();
      } else if (this.removeData.url == "customer/deleteuploadfile/") {
        let data = {
          Id: this.removeData.customerAttachmentId,
          Language: 0,
        };
        axios
          .delete(`${this.getUrl}/customer/deleteuploadfile/`, {
            data: data,
          })
          .then((data) => {
            if (data.data.status == 1) {
              this.$store.commit("setMessage", {
                message: "درخواست با موفقیت انجام شد",
                color: "success",
                timeOut: 2000,
              });
              this.closeDelete();
              this.getDataAttachment(this.selectedCustomer.customerId);
            } else if (data.data.status == 0) {
              this.$store.commit("setMessage", {
                message: data.data.message,
                color: "red",
                timeOut: 2000,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {});
      } else if (this.removeData.url == "customercontact/delete/") {
        let data = {
          Id: this.removeData.customerContactId,
          Language: 0,
        };
        axios
          .delete(`${this.getUrl}/customercontact/delete/`, {
            data: data,
          })
          .then((data) => {
            if (data.data.status == 1) {
              this.$store.commit("setMessage", {
                message: "درخواست با موفقیت انجام شد",
                color: "success",
                timeOut: 2000,
              });
              this.closeDelete();
              this.getDataContact(this.selectedCustomer.customerId);
            } else if (data.data.status == 0) {
              this.$store.commit("setMessage", {
                message: data.data.message,
                color: "red",
                timeOut: 2000,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {});
      }
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    // attachment
    getPerson() {
      this.$store.dispatch("sendList", { url: "person/list/", page: 1 });
    },
    getManCompanyFk(id) {
      let result = this.getPersonList.records.find((item) => {
        return item.id == id;
      });
      if (result) return `${result.firstName} ${result.lastName}`;
    },
    openFormAttachment(item) {
      this.image = null;
      this.selectedCustomer = item;
      this.getDataAttachment(this.selectedCustomer.customerId);
      console.log(
        this.selectedCustomer.customerId,
        "selectedCustomer.customerId"
      );
      this.attachmentForm = true;
    },
    deleteAttachment(item) {
      this.removeData = item;
      this.removeData.url = "customer/deleteuploadfile/";
      this.dialogDelete = true;
    },

    //contact
    openFormContact(item) {
      this.selectedCustomer = item;
      this.getDataContact(this.selectedCustomer.customerId);
      this.contactForm = true;
    },
    addContactItem() {
      if (this.$refs.contactAddForm.validate()) {
        axios
          .post(`${this.getUrl}/customercontact/create/`, {
            Language: 0,
            Title: this.contactAddData.title,
            Date: moment
              .from(this.contactAddData.date, "fa", "YYYY/MM/DD")
              .locale("en")
              .format("YYYY-MM-DDThh:mm:ss"),
            CustomerFk: this.selectedCustomer.customerId,
          })
          .then((data) => {
            if (data.data.status == 1) {
              this.getDataContact(this.selectedCustomer.customerId);
              this.$store.commit("setMessage", {
                message: "درخواست با موفقیت انجام شد",
                color: "success",
                timeOut: 2000,
              });
              this.contactAddForm = false;
            } else {
              this.$store.commit("setMessage", {
                message: data.data.messge,
                color: "red",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setMessage", {
              message: error.message,
              color: "red",
              timeOut: 2000,
            });
            console.log(error);
          });
      }
    },
    openContctEditForm(item) {
      this.contactEditData.data = JSON.parse(JSON.stringify(item));
      this.contactEditData.data.date = this.toPersianDate(
        this.contactEditData.data.date
      );
      this.contactEditForm = true;
    },
    editContactItem() {
      if (this.$refs.contactEditForm.validate()) {
        axios
          .put(`${this.getUrl}/customercontact/update/`, {
            Language: 0,
            Title: this.contactEditData.data.title,
            Date: moment
              .from(this.contactEditData.data.date, "fa", "YYYY/MM/DD")
              .locale("en")
              .format("YYYY-MM-DDThh:mm:ss"),
            CustomerFk: this.selectedCustomer.customerId,
            Id: this.contactEditData.data.customerContactId,
          })
          .then((data) => {
            if (data.data.status == 1) {
              this.getDataContact(this.selectedCustomer.customerId);
              this.$store.commit("setMessage", {
                message: "درخواست با موفقیت انجام شد",
                color: "success",
                timeOut: 2000,
              });
              this.contactEditForm = false;
            } else {
              this.$store.commit("setMessage", {
                message: data.data.messge,
                color: "red",
              });
            }
          })
          .catch((error) => {
            this.$store.commit("setMessage", {
              message: error.message,
              color: "red",
              timeOut: 2000,
            });
            console.log(error);
          });
      }
    },
    deleteContact(item) {
      this.removeData = item;
      this.removeData.url = "customercontact/delete/";
      this.dialogDelete = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.section__banks {
  background-color: #eeeeee !important;
  position: relative;
}
</style>
